import React from 'react';
import { styled } from 'styled-components';
import { Option, Select } from '@ingka/select';
import { useTranslation } from 'react-i18next';

interface FollowUpCoworkerPickerProps {
  sameCoworker: boolean;
  onChange: (sameCoworker: boolean) => void;
  isDisabled?: boolean;
}

const CoworkerField = styled.div`
  margin: 2rem 0 3rem;
`;

const StyledSelect = styled(Select)`
  &&& {
    width: 100%;

    .select__wrapper {
      max-width: 17rem;
      margin-top: 1rem;
    }
  }
`;

const FollowUpCoworkerPicker: React.FC<FollowUpCoworkerPickerProps> = ({
  sameCoworker,
  onChange,
  isDisabled,
}) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.currentTarget.value === 'same');
  };

  return (
    <CoworkerField>
      <StyledSelect
        id="followup-coworker"
        label={t('pages.followup.timeslots.coworkerSelectLabel')}
        hintText=""
        value={sameCoworker ? 'same' : 'any'}
        onChange={handleChange}
        disabled={isDisabled}
        data-cy="followup-coworker-picker"
      >
        <Option
          name={t('pages.followup.timeslots.sameCoworker')}
          value="same"
        />
        <Option name={t('pages.followup.timeslots.anyCoworker')} value="any" />
      </StyledSelect>
    </CoworkerField>
  );
};

export default FollowUpCoworkerPicker;
